"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var utils_1 = require("./utils");
function valueReducer(prevValue, nextValue) {
    if (lodash_isequal_1.default(prevValue, nextValue)) {
        return prevValue;
    }
    return nextValue;
}
function getValueOrDefault(tweekRepository, keyPath, defaultValue) {
    if (!tweekRepository) {
        return defaultValue;
    }
    var cached = tweekRepository.getCached(keyPath);
    if (!cached) {
        tweekRepository.prepare(keyPath);
        return defaultValue;
    }
    return cached.state === "cached" ? cached.value : defaultValue;
}
exports.createUseTweekValue = function (TweekContext, prepare) {
    function useTweekValue(keyPath, defaultValue) {
        utils_1.ensureHooks();
        var tweekRepository = react_1.default.useContext(TweekContext);
        var args = [tweekRepository, keyPath, defaultValue];
        var storedArgs = react_1.default.useRef(args);
        var getTweekValue = function () { return getValueOrDefault.apply(void 0, args); };
        var _a = react_1.default.useReducer(valueReducer, null, getTweekValue), tweekValue = _a[0], setTweekValue = _a[1];
        react_1.default.useEffect(function () {
            var newTweekValue = getTweekValue();
            if (!lodash_isequal_1.default(newTweekValue, tweekValue)) {
                setTweekValue(newTweekValue);
            }
            return (tweekRepository &&
                tweekRepository.listen(function (updatedKeys) {
                    if (updatedKeys.has(keyPath)) {
                        setTweekValue(getTweekValue());
                    }
                }));
        }, args);
        if (!lodash_isequal_1.default(args, storedArgs.current)) {
            storedArgs.current = args;
            return valueReducer(tweekValue, getTweekValue());
        }
        return tweekValue;
    }
    useTweekValue.create = function (keyPath, defaultValue) {
        prepare(keyPath);
        return function () { return useTweekValue(keyPath, defaultValue); };
    };
    return useTweekValue;
};
//# sourceMappingURL=createUseTweekValue.js.map


// WEBPACK FOOTER //
// ../src/createUseTweekValue.ts